import React from 'react';
import PropTypes from 'prop-types';

const WeightCell = ({ weight, weightUnit }) => {
  return (
    <span>
      {weight} {''}
      {weightUnit}
    </span>
  );
};

WeightCell.propTypes = {
  weight: PropTypes.string.isRequired,
  weightUnit: PropTypes.string.isRequired,
};

export default WeightCell;
